import React, { useEffect } from "react";
import useAuthenticationStore from "./Store";
import { useNavigate } from "react-router-dom";
import AddTotp from "./AddTotp";

const AddTotpContainer: React.FC = () => {
    const { state, enableTotp } = useAuthenticationStore();
    const { serverError, isLoading } = state;
    const navigate = useNavigate();

    useEffect(() => {
        if (!state.totpKey || !state.totpQrCodeUri) {
            navigate("../");
        }
    }, [state.totpKey, state.totpQrCodeUri, navigate]);

    const cancel = () => {
        navigate("../");
    }

    return (
        <AddTotp
            serverError={serverError}
            isLoading={isLoading}
            totpKey={state.totpKey!}
            totpQrCodeUri={state.totpQrCodeUri!}
            enableTotp={enableTotp}
            cancel={cancel}
        />
    );
};

export default AddTotpContainer;
